const getExtraEffectDateDescription = ({ description }) => description;

export default getExtraEffectDateDescription;
